/* Application form modal — aligned 1:1 to .design-ref/pim-admin/index.html
 * (ApplicationFormModal, pages.jsx L1480). Name + ClientId in a 2-col grid,
 * URL full-width, footer with hint left + actions right. */

.stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.grid2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--form-gap);
  align-items: end;

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
  }
}

/* monospace ClientId field (design `.input.mono`, 12.5px) */
.monoInput :global(input) {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: var(--font-size-s);
}

/* modal footer: hint left, actions right */
.foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}

.footHint {
  font-size: var(--font-size-s);
  color: var(--color-grey-light);
}

.footActions {
  display: flex;
  gap: 8px;
}
